import LineHeight from './LineHeight';
import { Wrapper } from './styled';

export interface IWrapperProps {
  lineHeight?: LineHeight;
}

export default Wrapper;
